import api from "../index";
import { apiUrl } from "../../utils/constants";

// Web consumers only read {id, name}; the backend `light=1` path drops the
// unused `categoryTags` preload. Mobile/legacy callers don't pass this flag
// so their response shape is unchanged.
export const GetCategories = (params) => {
  return api.get(apiUrl.categories, { params: { ...(params || {}), light: 1 } });
};
